

import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RolesUsuarioProps } from '../../interfaces/admin/UsuarioInterface';

export const defaultRoles: RolesUsuarioProps = {
   ModuloNuevoProceso:                                  false,
   ModuloBusqueda:                                      false,
   ModuloConsultas:                                     false,
   ModuloCatalogos:                                     false,
   ModuloLibrosElectronicos:                            false,
   ElaboradorAcuerdo:                                   false,
   ValidadorAcuerdo:                                    false,
   AutorizadorAcuerdo:                                  false,
   VisualizadorAcuerdo:                                 false,
   ElaboradorAcuerdoOficioso:                           false,
   GeneradorNotificacion:                               false,
   CelebradorAudiencia:                                 false,
   ElaboradorActaAudiencia:                             false,
   ValidadorActaAudiencia:                              false,
   AutorizadorActaAudiencia:                            false,
   VisualizadorActaAudiencia:                           false,
   EscaneadorAnexosEnAudiencia:                         false,
   ElaboradorSentencia:                                 false,
   AutorizadorSentencia:                                false,
   VisualizadorSentencia:                               false,
   ElaboradorSentenciaPublica:                          false,
   AutorizadorSentenciaPublica:                         false,
   VisualizadorSentenciaPublica:                        false,
   ElaboradorOficio:                                    false,
   AutorizadorOficio:                                   false,
   VisualizadorOficio:                                  false,
   ElaboradorExhortoLibrado:                            false,
   AutorizadorExhortoLibrado:                           false,
   VisualizadorExhortoLibrado:                          false,
   GeneradorListaAcuerdos:                              false,
   GeneradorListaEstrados:                              false,
   GeneradorListadoEnvio:                               false,
   GeneradorCaratulas:                                  false,
   ElaboradorCertificacion:                             false,
   VisualizadorConsultaCertificaciones:                 false,
   VisualizadorExpedienteVirtual:                       false,
   VisualizadorConsultaAudiencias:                      false,
   VisualizadorConsultaTramitesRecibidos:               false,
   VisualizadorConsultaAcuerdos:                        false,
   VisualizadorConsultaOficios:                         false,
   VisualizadorConsultaExhortosLibrados:                false,
   VisualizadorConsultaNotificaciones:                  false,
   VisualizadorConsultaExpedientesPorEtapaProcesal:     false,
   VisualizadorConsultaIncidentes:                      false,
   RegistrarExpedienteAnterior:                         false,
   RegistrarExhortoAnterior:                            false,
};

export interface stateProps {
    nombres:                            string;
    apellidos:                          string;
    correoElectronico:                  string;
    token:                              string;
    administrador:                      boolean;
    coordinador:                        boolean;
    restablecerContrasena:              boolean;
    roles:                              RolesUsuarioProps;
    idUnidad:                           number;
    unidad:                             string;
}

const initialState: stateProps = {
    token: '',
    nombres: '', 
    apellidos: '', 
    correoElectronico: '', 
    administrador: false,
    coordinador: false,
    restablecerContrasena: false,
    idUnidad: 0,
    unidad: '',
    roles: defaultRoles,
} as stateProps;

export const authSlice = createSlice({
    name: 'auth',
    initialState: initialState,
    reducers: {
        login: ( state, { payload } : PayloadAction<stateProps> ) => {
            state.token = payload.token;
            state.nombres = payload.nombres;
            state.apellidos = payload.apellidos;
            state.correoElectronico = payload.correoElectronico; 
            state.administrador = payload.administrador; 
            state.coordinador = payload.coordinador; 
            state.restablecerContrasena = payload.restablecerContrasena; 
            state.idUnidad = payload.idUnidad;
            state.unidad = payload.unidad;
            state.roles = payload.roles; 
        },
        logout: ( state ) => {     
            state.token = '';
            state.nombres = '';
            state.apellidos = '';
            state.correoElectronico = '';          
            state.administrador = false;          
            state.coordinador = false;          
            state.restablecerContrasena = false;       
            state.idUnidad = 0;
            state.unidad = '';
            state.roles = defaultRoles;          
        },
    },
})

export const { login, logout } = authSlice.actions

export default authSlice.reducer